import chartOfAccount from '@/api/accounting/chart-of-account'

import { baseState, baseMutations } from '@/store/mixins'

export const state = {
  ...baseState,
  account_types: [],
  parent_accounts: []
}

export const getters = {}

export const mutations = {
  ...baseMutations,
  SET_ACCOUNT_TYPES(state, account_types) {
    state.account_types = account_types
  },
  SET_PARENT_ACCOUNTS(state, parent_accounts) {
    state.parent_accounts = parent_accounts
  }
}

export const actions = {
  fetch(context, attributes = {}) {
    const params = Object.assign(
      {
        page: context.state.pagination.page,
        perPage: context.state.pagination.perPage,
        search: context.state.search
      },
      attributes
    )

    return chartOfAccount.get({ params }).then(response => {
      context.commit('RECEIVE_RESOURCES', response)
      return Promise.resolve(response)
    })
  },

  store(context, data) {
    return chartOfAccount.store(data)
  },

  async find(context, id) {
    return await chartOfAccount.find(id)
  },

  update(context, data) {
    return chartOfAccount.update(data)
  },

  destroy(context, id) {
    return chartOfAccount.destroy(id)
  },

  async dataBeforeCreate({ commit, state }) {
    if (!state.account_types.length > 0) {
      let response = await chartOfAccount.getaccounttype()
      commit('SET_ACCOUNT_TYPES', response)
    }
    if (!state.parent_accounts.length > 0) {
      let response = await chartOfAccount.getparentaccount()
      commit('SET_PARENT_ACCOUNTS', response)
    }
  },

  async getNewParentAccout({ commit }) {
    let response = await chartOfAccount.getparentaccount()
    commit('SET_PARENT_ACCOUNTS', response)
  }
}
